import styled, { css } from "styled-components";
import { colors } from "@/constants";
import { Link } from "react-router-dom";

export const Container = styled.div<{ $isfirst?: boolean; $alignitems?: string; $justifyContent?: string }>`
  display: flex;
  flex-direction: column;
  margin-top: ${props => props.$isfirst ? 0 : 18}px;
  padding-bottom: 18px;
  /* gap: 20px; */
  
  ${props => props.$alignitems && css`
      align-items: ${props.$alignitems};
  `}
  /* justify-content: ${props => props.$justifyContent || 'center'}; */
`;

export const Subcontainer = styled.div<{ $alignitems?: string; gridTemplateColumns?: string }>`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  padding: 0 18px;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: ${(props) => (props.$alignitems || 'flex-start')};
`;

export const Selo = styled.div`
  margin-top: 14px;
  transform: scale(.7);
`

export const ContentImage = styled(Link)`

`;

export const ProductImage = styled.img`
  width: 58px;
  height: 58px;
`;

export const ProductDescription = styled(Link)`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  text-align: left;
  text-decoration: none;
  color: ${colors.gray.gray60};
  max-height: 45px;
  text-overflow: ellipsis;
`;

export const DescriptionRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;

`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceRow = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  text-align: right;
  color: ${colors.brand.grafite};
`;

export const UnityPrice = styled.span`
  width: fit-content;
  height: 18px;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: ${colors.gray.gray10};
  font-family: Roboto, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 11.72px;
  text-align: center;
  color: ${colors.grey3};
`;

export const Price = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 12.89px;
  text-align: right;
  color: ${colors.gray.gray40};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RemoveButton = styled.button`
  border: none;
  background-color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
`;

export const RemoveButtonLabel = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  text-align: center;
  color: ${colors.gray.gray40};
  text-decoration: underline;
`;

export const PackingBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const Packing = styled.img`
  width: 21.4px;
  height: 21.4px;
`;

export const PackingLabel = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  text-align: left;
  color: ${colors.gray.gray60};
`;

export const PackingUnities = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 12.89px;
  text-align: left;
  color: ${colors.grey3};
`;

export const PackingDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CounterButton = styled.div``;

export const Unavailable = styled.div`
  font-size: 12px;
  font-weight: 500;
  padding: 10px 6px;
  border-radius: 6px;
  border: none;
  width: 100%;
  text-align: center;
  color: ${colors.grey3};
  background-color: ${colors.gray.gray10};
`;

export const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
`;

export const StockContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
  gap: 4px;
  width: 100%;
`;

export const IconContainer = styled.div<{ $radius?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.$radius || 6}px;
  height: 36px;
  width: 36px;
  padding: 6px;
  background-color: ${colors.gray.gray10};
`;

export const CounterContainer = styled.div`
  margin-top: 24px;
`;

export const OuterGrid = styled.div`
  display: grid;
  background-color: ${colors.brand.white};
  grid-template-columns: 1fr 4fr;
  border-bottom: 1px solid ${colors.background1};
`;

export const InnerBlock = styled.div<{ $extraPadding?: boolean }>`
  display: grid;
  grid-template-columns: 4fr 1fr;
  ${props => props.$extraPadding && css`
    padding-bottom: 10px;
  `}
  gap: 16px;
  padding-right: 18px;
  align-items: flex-start;
  justify-content: center;
`;

export const FlexPercentage = styled.div<{ $positive?: boolean, $negative?: boolean }>`
  width: 44px;
  min-width: 44px;
  height: 54px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 6px;
  border: solid 1px ${colors.gray.gray10};
  background-color:${(props) => (props.$positive ? colors.alert.green200 : props.$negative ? colors.alert.orange100 : colors.gray.gray10)};
  color: ${colors.brand.grafite};
`;

export const FlexPercentageLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 14.06px;
`;

export const LastPurchaseContainer = styled.div` 
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: calc(100% - 18px);
    height: 20px;
    padding: 4px 8px;
    border-radius: 4px;

    background-color: ${colors.gray.gray10};

    color: ${colors.brand.grafite};
    font-size: 11px;
`;

export const LastPurchaseLabel = styled.span`
    font-weight: 500;
`;

export const LastPurchaseValue = styled.span`
    font-weight: 700;
`;

export const LastPurchaseBox = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
`;